import { Carousel } from 'bootstrap'

$('.carousel').each(function(){
    var $this = this;
    new Carousel($this, {
		interval: 5000,
		pause: 'hover'
	})

    $(this).children('.carousel-indicators').children('.indicator')
		.first()
		.addClass('active')
})